import { ArrayNotEmpty, IsArray, IsInt, IsISO8601 } from 'class-validator';

export class GetSweetFaceMerchantTransactionsRequestDto {
  @IsArray()
  @ArrayNotEmpty()
  @IsInt({ each: true })
  merchantIdList: number[];

  @IsISO8601()
  startDate: string;

  @IsISO8601()
  endDate: string;
}